(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyPaymentLogListController', CompanyPaymentLogListController);

    CompanyPaymentLogListController.$inject = ['$scope', '$state', 'CompanyPaymentLog', 'ParseLinks', 'AlertService', 'CompanyPaymentLogCustom', 'AccountClearingRequestCustom'];

    function CompanyPaymentLogListController($scope, $state, CompanyPaymentLog, ParseLinks, AlertService, CompanyPaymentLogCustom, AccountClearingRequestCustom) {
        var vm = this;
        vm.sumPaymentAmount = 0;
        vm.sumWage = 0;
        vm.sumRemaindAmount = 0;
        vm.accountClearRequest = accountClearRequest;
        vm.activeClearRequest = {};
        loadAll();

        function loadAll() {


            vm.companyPaymentLogs = CompanyPaymentLogCustom.getActiveCompanyPaymentLogs().query(function (result) {
                calculateSum();
            });


            AccountClearingRequestCustom.getActiveCompanyAccountClearingRequest().query().$promise.then(function (result) {


                    vm.activeClearRequest = result;
                }
            );

        }


        function calculateSum() {
            sumPaymentAmount();
            sumWage();
            vm.sumPaymentAmount = Math.round(vm.sumPaymentAmount);
            vm.sumWage = Math.round(vm.sumWage);
            vm.sumRemaindAmount = vm.sumPaymentAmount - vm.sumWage;
        }

        function sumPaymentAmount() {
            angular.forEach(vm.companyPaymentLogs, function (p) {

                vm.sumPaymentAmount += p.paymentAmount;
            });

        }

        function sumWage() {
            angular.forEach(vm.companyPaymentLogs, function (p) {

                vm.sumWage += p.wageFeeAmount;
            });

        }

        function accountClearRequest() {
            AccountClearingRequestCustom.createNewAccountClearingRequest().save(function (result) {
                    $scope.$emit('tikonApp:accountClearingRequestUpdate', result);
                    loadAll();
                }
            );


        }


        //function transition () {
        //    $state.transitionTo($state.$current, {
        //        page: vm.page,
        //        sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
        //        search: vm.currentSearch
        //    });
        //}
    }
})();
